<template>
  <div class="contractors-header">
    <SidebarOpener />
    <div class="contractors-header__title">{{ $t('Contractors') }}</div>
    <div class="spacex-20">
      <Button size="small" icon="plus" @click.native="$emit('add-new')">
        {{ $t('Add new') }}
      </Button>
      <Button type="secondary" size="small" icon="excel" @click.native="openSupportChat">
        {{ $t('Import from Excel') }}
      </Button>
    </div>
  </div>
</template>

<script>
  import { openSupportChat } from '@/integrations';
  import Button from '@/components/ui-v2/Button';
  import SidebarOpener from '@/containers/top-menu/SidebarOpener';
  export default {
    name: 'ContractorsHeader',
    components: { SidebarOpener, Button },
    methods: {
      openSupportChat,
    },
  };
</script>
